<script setup lang="ts">
interface GenericFilterSelectProps {
  selectedValues: string[];
  choices: string[];
}

const props = defineProps<GenericFilterSelectProps>();
const emit = defineEmits<{ (event: 'apply', selectedItems: string[]): void }>();

const pendingValues = ref<string[]>([]);
watchEffect(
  () => (pendingValues.value = props.selectedValues.length == props.choices.length ? [] : props.selectedValues)
);

const toggle = (choice: string) => {
  if (pendingValues.value.includes(choice)) {
    pendingValues.value = pendingValues.value.filter((c) => c != choice);
  } else {
    pendingValues.value = pendingValues.value.concat(choice);
  }
};

const search = ref<string>('');
const filteredChoices = computed(() =>
  props.choices.filter((f) => search.value == '' || f.toLowerCase().includes(search.value.toLowerCase()))
);

const canApply = computed(() => pendingValues.value.length > 0);
</script>

<template>
  <div class="bg-[#F4F6FB] min-w-125px shadow-[0_4px_4px_rgba(0,0,0,0.16)] flex flex-col items-center rounded-1">
    <div class="p-3 w-full box-border">
      <div class="w-full border-b-1 border-solid border-0 border-[#828282]">
        <input
          size="1"
          v-model="search"
          class="w-full border-0 bg-[#F4F6FB] text-[#4F4F4F] text-xs mobile:text-4 focus:outline-none font-family[Roboto]"
          placeholder="Search..."
        />
      </div>
    </div>
    <div class="flex flex-col self-start overflow-auto max-h-250px">
      <div
        class="flex flex-row items-center cursor-pointer px-3 mobile:py-2 py-1 hover:bg-[#CFD6E2]"
        @click="toggle(choice)"
        v-for="choice in filteredChoices"
        :key="choice"
      >
        <div
          class="text-4 color-[#4F4F4F]"
          :class="{
            'i-mdi-checkbox-marked': pendingValues.includes(choice),
            'i-mdi-checkbox-blank-outline': !pendingValues.includes(choice),
          }"
        />
        <div class="pl-1.5 text-[#4F4F4F] font-family[Roboto] text-xs mobile:text-4 whitespace-nowrap truncate">
          {{ choice }}
        </div>
      </div>
    </div>
    <div
      @click="canApply && emit('apply', pendingValues)"
      :class="{
        'text-[#C73362] underline': canApply,
        'text-[#94A3B8]': !canApply,
      }"
      class="flex cursor-pointer items-center font-family[Roboto] uppercase text-3 mobile:text-4 py-3 px-3"
    >
      Apply
    </div>
  </div>
</template>
